<template>
  <div class="baseCard">
	<div class="state">{{dataList.state}}</div>
    <p class="title" style="margin-top: 20px;margin-bottom: 0;">{{dataList.title}}</p>
    <!-- <p class="date">项目启动时间：{{dataList.project_star_time}}</p> -->
    <div class="detailItem">
      <p><img src="../../assets/img/hsz_icon_little.png" alt="">基本信息</p>
      <div class="detailItemOne">
        <img
          class="detailItemOneImg"
          :src="dataList.title_img"
          alt=""
        >
        <div class="detailItemOneList">
          <div class="detailItemOneItem">
            <img
              src="../../assets/img/shouru.png"
              alt=""
            >
            <span class="itemTitle">项目收入(元) </span>
            <span class="itemNum">{{dataList.pro_income}}</span>
          </div>
          <div class="detailItemOneItem">
            <img
              src="../../assets/img/zhichu.png"
              alt=""
            >
            <span class="itemTitle">当前支出(元) </span>
            <span class="itemNum">{{dataList.pro_expenditure}}</span>
          </div>
          <div class="detailItemOneItem">
            <img
              src="../../assets/img/yue.png"
              alt=""
            >
            <span class="itemTitle">当前余额(元) </span>
            <span class="itemNum">{{dataList.balance}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="detailItem">
      <p><img src="../../assets/img/hsz_icon_little.png" alt="">项目介绍</p>
      <div v-html="dataList.project_introduction">
        dataList.project_introduction
      </div>
    </div>
    <div class="detailItem">
      <p><img src="../../assets/img/hsz_icon_little.png" alt="">项目背景</p>
      <div v-html="dataList.project_background">
        dataList.project_background
      </div>
    </div>
    <div class="detailItem">
		<p>
		  <img src="../../assets/img/hsz_icon_little.png" alt="">扫描二维码捐款
		  <span v-if="dataList.remark" style="color: #b60303;margin-left: 5px;">({{dataList.remark}})</span>
		</p>
      <div class="QRimg">
			<img :src="dataList.QR_code">
      </div>
    </div>
  </div>
</template>

<script>
import apiUrls from "@/api";
export default {
  data() {
    return {
		dataList: {}
	};
  },
  mounted() {
	  console.log(this.$route.query.id)
	  this.getData(this.$route.query.id)
  },
  methods: {
	  getData(id) {
	  	apiUrls.getById({id: id}).then(res => {
	  		console.log("idData",res.results.fieldDescription)
			this.dataList = res.results.data
			console.log("datalist",this.dataList)
	  	})
	  },
  },
};
</script>
<style lang="less" scoped>
.baseCard {
  border: 1px solid #d8d8d8;
  position: relative;
  .state {
	  position: absolute;
	  top: 0;
	  right: 0;
	  background: #C11818;
	  width: 85px;
	  height: 33px;
	  border-radius: 0 0 0 33px;
	  padding-left: 12px;
	  font-size: 14px;
	  color: #FFFFFF;
	  text-align: center;
	  line-height: 33px;
  }
  .title {
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    text-align: center;
  }
  .date {
    font-size: 14px;
    font-family: "MicrosoftYaHeiUI";
    color: #333333;
    text-align: center;
    padding-bottom: 20px;
    border-bottom: 1px dotted #d8d8d8;
  }
  .detailItem {
    padding: 20px;
    border-bottom: 1px dotted #d8d8d8;
    p {
      font-size: 14px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      img{
          margin-right:10px;
      }
    }
    .detailItemOne {
      display: flex;
      justify-content: space-between;
      .detailItemOneImg {
        width: 375px;
        height: 249px;
      }
      .detailItemOneList {
        display: flex;
        flex-direction: column;
        width: calc(100% - 375px);
        .detailItemOneItem {
          display: flex;
          //   justify-content: space-around;
          align-items: center;
          padding-left: 50px;
          img {
            width: 42px;
            height: 42px;
            margin: 10px;
          }
          .itemTitle {
            font-size: 14px;
            font-family: "MicrosoftYaHeiUI";
            color: #333333;
            margin: 10px;
          }
          .itemNum {
            font-size: 50px;
            font-family: "YJSZ";
            color: #b60303;
          }
        }
      }
    }
    .shouMain {
      width: 100%;
      display: flex;
      justify-content: space-between;
      .shouItem {
        width: 570px;
        height: 243px;
        background: #fff8f6;
        border: 1px solid #ffbb87;
        padding: 20px;
		textarea {
			width: 100%;
			height: 100%;
			background: rgba(0,0,0,0);
			border: 0;
			outline: none;
		}
        .shouItemP {
          display: flex;
          justify-content: space-between;
          border-bottom: 1px dotted #d8d8d8;
          margin-top: 10px;
          .shouItemDate {
            font-size: 14px;
            font-family: "MicrosoftYaHeiUI";
            color: #aeaeae;
            line-height: 18px;
          }
        }
        .shouItemLi {
          border-bottom: 1px dotted #d8d8d8;
          margin-top: 10px;
          .shouItemLiText1 {
            font-size: 14px;
            font-family: "MicrosoftYaHeiUI";
            color: #333333;
            line-height: 18px;
          }
          .shouItemLiText2 {
            font-size: 14px;
            font-family: "MicrosoftYaHeiUI";
            color: #aeaeae;
            line-height: 18px;
          }
        }
      }
    }
	.QRimg {
		height: 260px;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		img {
			width: 281px;
			height: 256px;
		}
	}
  }
}
</style>